<template lang="pug">
  v-layout(column)
    field-value(
      v-for="field in card.fields"
      is-profile-v2
      :row-name="field.label"
      :key="field.id"
      :ref="field.id"
      :field-labels="labels"
      :field-name="field.name"
      :field-type="field.data_type"
      :validations="[validations[customFieldValidation(field.data_type)] || true]"
      :is-contact-owner="isContactOwner"
      :dropdown-items="field.options"
      :field-label="field.name"
      v-model="field.value"
      full-width 
      @input='onChange($event, field)'
      @field-status="fieldStatusChange"
      :is-custom-field="isCustomFieldsCard"
      :isSwitchInverted="field.isInverted"
      :switchOffLabel="field.offLabel"
      :error-types="fieldValueErrorTypes"
      :error-messages="fieldValueErrorMessages"
      :disabled="card.card_id === 'contact_owner_custom_fields'"
    )
    div.d-flex.justify-center
      v-btn(
        v-if="card.shouldShowLess" 
        class="card-action pa-2" 
        @click="$emit('click:showless')" 
        :disabled="isContactOwnerCustomFieldsLoading"
      ) Show less...
      v-btn(
        v-if="card.shouldShowMore" 
        class="card-action pa-2" 
        @click="$emit('click:showmore')" 
        :disabled="isContactOwnerCustomFieldsLoading"
      ) Show more...
    div.pa-2.info-text(v-if="card.card_id === 'contact_owner_custom_fields'")
      v-icon.mr-1(small) info
      span For any change on these custom fields, contact {{ getContactOwnerName() }} via email or @mention on a comment in this Contact Profile.
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import FieldValueV2 from './FieldValueV2';
import FieldValue from '@/Contacts/components/profile/FieldValue';
import ContactInfo from '@/Contacts/mixins/ContactInfo';

const {
  mapMutations: mapContactsMutations,
  mapGetters: mapContactGetters,
  mapState: mapContactSate,
} = createNamespacedHelpers('contact');

const { mapGetters: mapTeamMembersGetters } = createNamespacedHelpers('teamMembers');

export default {
  components: {
    FieldValueV2,
    FieldValue,
  },
  mixins: [ContactInfo],
  props: {
    card: {
      required: true,
      default: {}
    },
    fieldValueErrorMessages: {
      type: Object,
      default: [],
    },
    fieldValueErrorTypes: {
      type: Array,
      default: {},
    },
  },
  computed: {
    ...mapContactGetters(['currentUserInfo']),
    ...mapTeamMembersGetters(['teamMembersInfo']),
    ...mapContactGetters(['currentContact']),
    ...mapContactSate(['isContactOwnerCustomFieldsLoading']),
    isCustomFieldsCard() {
      return this.card.card_id === "custom_fields";
    },
  },
  methods: {
    ...mapContactsMutations(['setContactProfileUnsavedFields']),
    setPatchFields(field) {
      this.setContactProfileUnsavedFields(field);
    },
    onChange(newValue, field) {
      if (this.card.card_id === 'contact_owner_custom_fields') return;

      const fieldValue = { 
        type: field.data_type, 
        custom: this.isCustomFieldsCard,
        name: this.isCustomFieldsCard ? field.name : field.id,
        id: this.isCustomFieldsCard ? field.id : null,
      };
      this.$emit('input', newValue, fieldValue);
    },
    fieldStatusChange(field) {
      this.$emit('field-status-change', field);
    },
    getContactOwnerName() {
      if (this.card.card_id !== 'contact_owner_custom_fields' || this.card.contact_owner_name === "") return '';
      return this.card.contact_owner_name || '' ;
    },
  },
}
</script>
<style lang="scss" scoped>
.card-action {
  color: #f7883e;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.44px;
  line-height: 16px;
  padding: 0px;
  margin: 0px;
  min-width: 60px;
  background: transparent !important;
  text-transform: none;
}
.card-action.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  opacity: 0.8;
  color: #f7883e !important;
  background: transparent !important;
  background-color: transparent !important;
}
.info-text {
  color: rgba(0,0,0,0.54);
  font-size: 10px;
}
</style>
